import {
	AcademicPartnerMerchandisingTier,
	GetMemberProgramQuery,
	GetMemberProgramsV2Query,
	OfferingCardFragment,
	ShortProgramKind,
} from 'src/graphqlTypes/catalogServiceTypes';
import { OfferingHit } from 'src/queries/user';
import { HITS_PER_PAGE } from 'src/components/Providers/SearchProvider/helpers';
import { ProgramFormat } from '@src/constants/programFormat';
import { BookmarkType } from '@src/components/Providers/BookmarksProvider';

export const hitInOfferings = (id: string, offerings: BookmarkType[]): boolean => {
	return offerings.some(offering => offering.id === id);
};

export const isBookmarked = (programId: string, userBookmarks: BookmarkType[]): boolean => {
	return userBookmarks ? hitInOfferings(programId, userBookmarks) : false;
};

export const isAffiliateProgram = (
	program: GetMemberProgramQuery['memberProgram'] | GetMemberProgramsV2Query['memberPrograms'][0]
) => {
	return (
		program?.studentFacingAcademicPartner?.merchandisingTier.toUpperCase() ===
		AcademicPartnerMerchandisingTier.AFFILIATE
	);
};

export const toggleOfferingId = (newOfferingId: string, userBookmarkIds: string[]) => {
	let updatedOfferingIds: string[] = [...userBookmarkIds];

	if (userBookmarkIds.some(id => id === newOfferingId)) {
		updatedOfferingIds = userBookmarkIds.filter(id => id !== newOfferingId);
	} else {
		updatedOfferingIds.push(newOfferingId);
	}

	return updatedOfferingIds;
};

export const setPosition = (page: number, index: number): number => {
	// HITS_PER_PAGE is set by us and is currently set to 10
	return page * HITS_PER_PAGE + index + 1;
};

export const toOfferingHit = (value: { program: OfferingCardFragment }): OfferingHit => {
	return {
		activatedAt: value.program.activatedAt,
		completionTimeDisplay: value.program.completionTimeDisplay,
		concentrations: value.program.concentrations,
		featured: value.program.featured,
		id: value.program.id,
		maxCompletionDays: value.program.maxCompletionDays,
		maxCompletionTimeDisplay: value.program.maxCompletionTimeDisplay,
		minCompletionDays: value.program.minCompletionDays,
		minCompletionTimeDisplay: value.program.minCompletionTimeDisplay,
		name: value.program.name,
		nextDates: {
			appDueDate: value.program.nextDate && value.program.nextDate.appDueDate,
			startDate: value.program.nextDate && value.program.nextDate.startDate,
		},
		nextDate: {
			appDueDate: value.program.nextDate && value.program.nextDate.appDueDate,
			startDate: value.program.nextDate && value.program.nextDate.startDate,
		},
		programFormat: value.program.programFormat as ProgramFormat,
		shortProgramKind: value.program.shortProgramKind as ShortProgramKind,
		studentFacingAcademicPartner: value.program.studentFacingAcademicPartner,
		uuid: value.program.uuid,
	};
};
